import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtMoney } from "@/lib/lineMath";

const Cell = ({ label, value, strong, testId, hide }) => (
  <div className={`text-right ${hide ? "hidden 2xl:block" : ""}`} data-testid={testId}>
    <div className="text-[9px] uppercase tracking-widest font-mono text-slate-500">{label}</div>
    <div className={`font-mono tabular-nums ${strong ? "text-lg font-bold text-white" : "text-[13px] text-slate-300"}`}>{value}</div>
  </div>
);

export default function TotalsFooter({ totals, before, dirtyCount, saving, readOnly, onDiscard, onSave }) {
  const multi = Object.keys(totals).length > 1;
  return (
    <div className="shrink-0 border-t border-slate-800 bg-slate-950/95 backdrop-blur px-4 sm:px-6 py-2.5 flex flex-wrap lg:flex-nowrap items-center gap-x-6 gap-y-2"
      data-testid="ws-footer">
      <div className="min-w-[170px] shrink-0">
        {dirtyCount > 0 ? (
          <div className="flex items-center gap-2 text-xs text-amber-300" data-testid="ws-dirty-count">
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
            {dirtyCount} satırda kaydedilmemiş değişiklik
          </div>
        ) : <div className="text-xs text-slate-500" data-testid="ws-clean">Kaydedilmemiş değişiklik yok</div>}
      </div>
      <div className="flex flex-wrap gap-x-7 gap-y-2 ml-auto min-w-0">
        {Object.entries(totals).map(([cur, t]) => (
          <div key={cur} className="flex items-end gap-5 pl-5 border-l border-slate-800 first:border-l-0 first:pl-0" data-testid={`ws-total-${cur}`}>
            <Cell hide={multi} label={`Ara Toplam ${cur}`} value={fmtMoney(t.subtotal, cur)} testId={`ws-total-sub-${cur}`} />
            <Cell hide={multi} label="İskonto" value={`-${fmtMoney(t.discount, cur)}`} testId={`ws-total-disc-${cur}`} />
            <Cell hide={multi} label="KDV" value={fmtMoney(t.tax, cur)} testId={`ws-total-tax-${cur}`} />
            <div className="text-right" title={`Ara Toplam ${fmtMoney(t.subtotal, cur)} · İskonto -${fmtMoney(t.discount, cur)} · KDV ${fmtMoney(t.tax, cur)}`}>
              <div className="text-[9px] uppercase tracking-widest font-mono text-slate-500">Genel {cur}</div>
              {before?.[cur] && Math.abs(before[cur].total - t.total) > 0.004 && (
                <div className="text-[10px] font-mono text-slate-500 line-through leading-none" data-testid={`ws-total-was-${cur}`}>{fmtMoney(before[cur].total, cur)}</div>
              )}
              <div className="font-mono tabular-nums text-lg font-bold text-emerald-300" data-testid={`ws-total-grand-${cur}`}>{fmtMoney(t.total, cur)}</div>
            </div>
          </div>
        ))}
      </div>
      {!readOnly && (
        <div className="flex items-center gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={onDiscard} disabled={!dirtyCount || saving} data-testid="ws-discard"
            className="rounded-sm border-slate-700 h-9">İptal</Button>
          <Button size="sm" onClick={onSave} disabled={!dirtyCount || saving} data-testid="ws-save"
            className="rounded-sm h-9 px-4 bg-emerald-600 hover:bg-emerald-500 font-semibold">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4 mr-1.5" /> Değişiklikleri Kaydet</>}
          </Button>
        </div>
      )}
    </div>
  );
}
